import { useParams } from "react-router-dom";
import { isOpenNow } from "@/lib/businessHours";

const OPEN = { tr: "Şu an açık", en: "Open now", el: "Ανοιχτά τώρα", ru: "Сейчас открыто", fa: "اکنون باز است" };
const CLOSED = { tr: "Şu an kapalı", en: "Closed now", el: "Κλειστά τώρα", ru: "Сейчас закрыто", fa: "اکنون بسته است" };

export default function OpenNowBadge({ className = "" }) {
  const { lang } = useParams();
  const open = isOpenNow();
  const label = open ? OPEN[lang] || OPEN.en : CLOSED[lang] || CLOSED.en;
  return (
    <span
      data-testid="open-now-badge"
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${open ? "bg-green-500/15 text-green-400" : "bg-white/10 text-faint"} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${open ? "bg-green-400 animate-pulse" : "bg-faint"}`} />
      {label}
    </span>
  );
}
